import { MapPin, Phone, Mail, Navigation } from "lucide-react";
import {
  BookLink,
  Chapter,
  Reveal,
  PHONE_TEL,
  PHONE_DISPLAY,
  EMAIL,
  ADDRESS_LINE,
  ADDRESS_CITY,
  DIRECTIONS_URL,
} from "./booking";

export default function Visit() {
  return (
    <section id="contact" data-testid="visit-section" className="px-5 lg:px-12 py-20 lg:py-32 border-t border-border">
      <Chapter index="07" title="Visit Us" />
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
        <div>
          <Reveal>
            <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
              Pull up.
              <br />
              <span className="text-primary">Springfield, VA.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="mt-10 space-y-6">
            <div className="flex gap-4 items-start">
              <MapPin size={20} className="text-primary mt-1 shrink-0" aria-hidden="true" />
              <div>
                <p className="font-semibold text-lg">Faded Barber Co.</p>
                <p className="text-muted-foreground font-light">
                  {ADDRESS_LINE}
                  <br />
                  {ADDRESS_CITY}
                </p>
                <p className="mt-1 text-sm text-muted-foreground/70 font-light">
                  Serving Springfield, Alexandria &amp; Northern Virginia.
                </p>
              </div>
            </div>
            <div className="flex gap-4 items-center">
              <Phone size={20} className="text-primary shrink-0" aria-hidden="true" />
              <a
                href={PHONE_TEL}
                data-testid="contact-phone-link"
                className="text-lg font-semibold hover:text-primary transition-colors duration-300"
              >
                {PHONE_DISPLAY}
              </a>
            </div>
            <div className="flex gap-4 items-center">
              <Mail size={20} className="text-primary shrink-0" aria-hidden="true" />
              <a
                href={`mailto:${EMAIL}`}
                data-testid="contact-email-link"
                className="text-lg font-semibold hover:text-primary transition-colors duration-300"
              >
                {EMAIL}
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.25} className="mt-10 flex flex-col sm:flex-row flex-wrap gap-3">
            <BookLink testid="contact-book-button" className="btn-primary">
              Book an Appointment
            </BookLink>
            <a
              href={DIRECTIONS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="directions-button"
              className="btn-outline"
            >
              <Navigation size={16} aria-hidden="true" /> Get Directions
            </a>
            <a href={PHONE_TEL} data-testid="contact-call-button" className="btn-outline">
              <Phone size={16} aria-hidden="true" /> Call Now
            </a>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="border border-border overflow-hidden min-h-[380px]">
          <iframe
            title="Map to Faded Barber Co., 6803 Backlick Rd # B, Springfield, VA 22150"
            src="https://www.google.com/maps?q=Faded+Barber+Co,+6803+Backlick+Rd,+Springfield,+VA+22150&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="location-map"
            className="w-full h-full min-h-[380px] map-dark"
          />
        </Reveal>
      </div>
    </section>
  );
}
